import { put, takeEvery } from 'redux-saga/effects';

import { processRequestError } from './index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, consistent-return
const getFirstErrorMessage = (data: any): any => {
  if (Array.isArray(data)) {
    // eslint-disable-next-line no-restricted-syntax
    for (const arrayItem of data) {
      return getFirstErrorMessage(arrayItem);
    }
  } else if (typeof data === 'object') {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const objectKey in data) {
      return getFirstErrorMessage(data[objectKey]);
    }
  } else {
    return data;
  }
};

function* processRequestErrorSaga({
  payload: { error, failAction },
}: ReturnType<typeof processRequestError>) {
  const errors = { message: 'Request failed!' };

  if (error.response) {
    const { data } = error.response;

    if (data) {
      errors.message = getFirstErrorMessage(data);
    } else {
      errors.message = 'Server error';
    }
  } else if (error.request) {
    // The request was made but no response was received
    if (error.request.status === 0) {
      errors.message = 'Network error';
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    errors.message = 'Something went wrong';
  }

  yield put(failAction(errors));
}

export function* watchErrors() {
  yield takeEvery(processRequestError, processRequestErrorSaga);
}
